import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section className="py-24 sm:py-32" data-testid="final-cta">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-[32px] p-10 sm:p-16 lg:p-24 border border-white/10"
          style={{ background: "linear-gradient(135deg, #0d1836 0%, #0A1023 40%, #08221a 100%)" }}
        >
          <div className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full blur-[140px] opacity-40"
            style={{ background: "radial-gradient(circle, #10B981, transparent 70%)" }} />
          <div className="absolute -bottom-40 -left-40 w-[520px] h-[520px] rounded-full blur-[140px] opacity-30"
            style={{ background: "radial-gradient(circle, #1E3A8A, transparent 70%)" }} />

          <div className="relative">
            <p className="font-inter text-[11px] uppercase tracking-[0.28em] text-[#10B981] font-semibold mb-6">Your US career, one call away</p>
            <h2 className="font-poppins text-4xl sm:text-5xl lg:text-6xl font-semibold text-white leading-[1.05] tracking-tight max-w-3xl">
              Ready to launch your <span className="text-gradient">US tech career?</span>
            </h2>
            <p className="font-inter text-white/60 mt-6 max-w-2xl text-lg">
              Book a free 30-minute consultation with a senior US career advisor. Get a resume audit, visa strategy and a personalized roadmap — all in one call.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link
                to="/contact"
                data-testid="final-cta-book"
                className="inline-flex items-center gap-2 text-white font-inter font-medium text-sm px-6 py-3.5 rounded-full"
                style={{ background: "linear-gradient(120deg, #1E3A8A, #10B981)", boxShadow: "0 20px 40px -12px rgba(16,185,129,0.5)" }}
              >
                Book Free Consultation <ArrowRight className="w-4 h-4" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 text-white/85 font-inter text-sm px-6 py-3.5 rounded-full border border-white/10 hover:bg-white/5"
              >
                Upload Your Resume
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
